import { PredefinedCommentValidationProvider } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/providers/predefined-comment-validation-form.provider';
import { PredefinedCommentFormProvider } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/providers/predefined-comment-form.provider';
import { PredefinedCommentFormContent } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/components/predefined-comment-form-content/predefined-comment-form-content.component';

export const SettingsDevicesPredefinedCommentsFormContainer: React.FC = () => (
    <PredefinedCommentFormProvider>
        <PredefinedCommentValidationProvider>
            <PredefinedCommentFormContent />
        </PredefinedCommentValidationProvider>
    </PredefinedCommentFormProvider>
);
